import { Map, List } from 'immutable'

import profileService from '../services/profile'

const defaultState = Map({
  groupDriversProfiles: List(),
  savedProfile: null
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case 'profile/GET_GROUPS':
      return state.update('groupDriversProfiles', profiles => List(action.payload))

    case 'profile/SET_SAVED':
      return state.update('savedProfile', saved => action.payload)

    default:
      return state
  }
}

export function getGroupDriversProfiles(organisationId) {
  return function d(dispatch) {
    dispatch({ type: 'profile/GET_GROUPS', payload: null })

    return profileService.getGroupDriversProfiles(organisationId).then(response => {
      dispatch({ type: 'profile/GET_GROUPS', payload: response.data.profiles })
    })
  }
}

export function saveGroupDriversProfile(organisationId, name, uuids) {
  return function d(dispatch) {
    return profileService
      .saveGroupDriversProfile(organisationId, name, uuids)
      .then(response => {
        setSavedProfile(true)(dispatch)
        getGroupDriversProfiles(organisationId)(dispatch)

        setTimeout(() => setSavedProfile()(dispatch), 7500)
      })
      .catch(() => {})
  }
}

export function setSavedProfile(isSaved) {
  return function d(dispatch) {
    dispatch({ type: 'profile/SET_SAVED', payload: isSaved })
  }
}



// WEBPACK FOOTER //
// ./src/ducks/group-drivers.js